import React from 'react';
import {
  $createRangeSelection,
  $getSelection,
  $isNodeSelection,
  $isRangeSelection,
  $isRootNode,
  $setSelection,
  COMMAND_PRIORITY_LOW,
  createCommand,
} from 'lexical';
import { mergeRegister } from '@lexical/utils';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { $createHtmlNode, HtmlNode } from '../nodes/html/HtmlNode';
import { $insertAndSelectNode } from '../utils/$insertAndSelectNode';

export const INSERT_HTML_COMMAND = createCommand();

export const HtmlPlugin = () => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    if (!editor.hasNodes([HtmlNode])) {
      console.error('HtmlPlugin: HtmlNode not registered'); // eslint-disable-line no-console
      return;
    }

    return mergeRegister(
      editor.registerCommand(
        INSERT_HTML_COMMAND,
        async dataset => {
          const htmlNode = $createHtmlNode(dataset);

          let focusNode;

          let selection = $getSelection();

          if (!selection) {
            const rangeSelection = $createRangeSelection();
            $setSelection(rangeSelection);
            selection = rangeSelection;
          }

          if ($isRangeSelection(selection)) {
            focusNode = selection.focus.getNode();

            if ($isRootNode(focusNode)) {
              focusNode = focusNode.getFirstChild();
            }
          } else if ($isNodeSelection(selection)) {
            focusNode = selection.getNodes()[0];
          } else {
            return false;
          }

          if (focusNode !== null) {
            $insertAndSelectNode({
              selectedNode: focusNode,
              newNode: htmlNode,
            });
          }

          return true;
        },
        COMMAND_PRIORITY_LOW,
      ),
    );
  }, [editor]);

  return null;
};

export default HtmlPlugin;
